import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import { displayFitRating } from '../../apps/product/utils';
import { FIT_RATINGS } from '../../config/constants-sizes';
import css from './Fit.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SPRINGS_PRODUCT_ID = 6721668229;

var Fit = function Fit(_ref) {
  var colorway = _ref.colorway,
      fitRatingAvg = _ref.fitRatingAvg,
      reviewCount = _ref.reviewCount,
      shopifyId = _ref.shopifyId;

  if (!displayFitRating(colorway, reviewCount)) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var max = 5;
  var barArr = new Array(max).fill();
  var is78Springs = shopifyId === SPRINGS_PRODUCT_ID;
  var value = is78Springs ? 1 : fitRatingAvg;
  var integer = Math.floor(value);
  var float = value % 1;
  var pastHalf = float > 0.5;
  var fitIndex = pastHalf ? integer + 1 : integer;
  return /*#__PURE__*/_jsxs("div", {
    "aria-label": "Users think this product fit is \"".concat(FIT_RATINGS[fitIndex], "\""),
    className: css.root,
    role: "img",
    children: [/*#__PURE__*/_jsx("div", {
      className: css.title,
      children: "Average Fit:"
    }), /*#__PURE__*/_jsx("ul", {
      className: css.bars,
      "data-rating": value,
      children: barArr.map(function (el, index) {
        return /*#__PURE__*/_jsx("li", {
          className: cc([css.bar, _defineProperty({}, css.darkBar, fitIndex === index && reviewCount > 0)]),
          role: "presentation",
          style: {
            width: "calc((100% - ".concat((max - 1) * 2, "px) / ").concat(max, ")")
          }
        }, "bar-".concat(index));
      })
    }), /*#__PURE__*/_jsxs("div", {
      "ada-hidden": "true",
      className: css.labels,
      role: "presentation",
      children: [/*#__PURE__*/_jsx("span", {
        "ada-hidden": "true",
        className: css.label,
        children: "Small"
      }), /*#__PURE__*/_jsx("span", {
        "ada-hidden": "true",
        className: css.label,
        children: "True to Size"
      }), /*#__PURE__*/_jsx("span", {
        "ada-hidden": "true",
        className: css.label,
        children: "Large"
      })]
    })]
  });
};

Fit.propTypes = {
  colorway: PropTypes.shape({}),
  fitRatingAvg: PropTypes.number,
  reviewCount: PropTypes.number,
  shopifyId: PropTypes.number
};
export default Fit;